import { Modal } from "bootstrap";
import UserDetailAppointments from "./UserDetailAppointments.vue";
import UserDetail from "../../Users/UserDetail/UserDetail.vue";
import UserChangeLogsTab from "@/components/UserChangeLogsTab.vue";

import { changeActive, changeEmail, reactivateUser } from "./userFunctions";
import { email, required } from "vuelidate/lib/validators";
import ListMixinController from "@/mixins/ListMixinController";

export default {
  mixins: [ListMixinController],
  mounted() {
    this.changeEmailModal = new Modal(
      document.getElementById("changeEmailModal"),
      {
        backdrop: "static",
        keyboard: false,
      }
    );
    this.freeAppointmentModal = new Modal(
      document.getElementById("freeAppointmentModal"),
      {
        backdrop: "static",
        keyboard: false,
      }
    );
    this.userPartnershipCodeModal = new Modal(
      document.getElementById("userPartnershipCodeModal"),
      {
        backdrop: "static",
        keyboard: false,
      }
    );
    this.loading = true;
    this.getUser();
  },
  computed: {
    userSession() {
      return this.$store.state.userSession;
    },
  },
  data() {
    return {
      loading: false,
      changeEmailModal: null,
      freeAppointmentModal: null,
      userPartnershipCodeModal: null,
      loadingChat: false,
      item: {},
      id: this.$route.params.id,
      loadingBlock: false,
      submitting: false,
      errorMessage: "",
      changeLogsLoaded: false,
      appointmentsLoaded: false,
      form: {
        email: "",
      },
      freeAppointmentForm: {
        user_id: Number(this.$route.params.id),
        psychologist_id: null,
        date: "",
      },
      psychologists: [],
      userPartnershipCodes: [],
      selectedUserPartnershipCodeId: null,
      loadingUserPartnershipCodes: false,
      updatingUserPartnershipCode: false,
      userPartnershipCodeError: "",
      showReactivateModal: false,
      confirmReactivate: false,
      reactivating: false,
      showResetPasswordModal: false,
      generatingResetLink: false,
      resetPasswordLink: null,
      cancelingRecurrency: null,
      showEditRecurrencyModal: false,
      submittingEditRecurrency: false,
      editRecurrencyForm: {
        recurrency: null,
        value: null,
        effective_date: "",
      },
    };
  },
  computed: {
    today() {
      return this.$moment().format("YYYY-MM-DD");
    },
    canSubmitEditRecurrency() {
      return (
        this.editRecurrencyForm.value >= 50 &&
        !!this.editRecurrencyForm.effective_date
      );
    },
    editRecurrencyValueBelowMin() {
      return (
        this.editRecurrencyForm.value != null &&
        this.editRecurrencyForm.value < 50
      );
    },
    editRecurrencyChangePct() {
      const current = parseFloat(this.editRecurrencyForm.recurrency?.value);
      const next = parseFloat(this.editRecurrencyForm.value);
      if (!current || !next) return 0;
      return ((next - current) / current) * 100;
    },
    editRecurrencyBigChange() {
      return Math.abs(this.editRecurrencyChangePct) >= 20;
    },
    editRecurrencyChangePctFormatted() {
      const pct = this.editRecurrencyChangePct;
      const sign = pct > 0 ? "+" : "";
      return `${sign}${pct.toFixed(1)}%`;
    },
  },
  validations: {
    freeAppointmentForm: {
      user_id: { required },
      psychologist_id: { required },
      date: { required },
    },
    form: {
      email: {
        required,
        email,
      },
    },
  },
  methods: {
    formatPeriod(period) {
      const periods = {
        monthly: "Mensal",
        yearly: "Anual",
      };
      return periods[period] || period;
    },
    getCountryFlag(countryCode) {
      // Remove o + se vier com ele
      const code = String(countryCode).replace("+", "");

      // Mapeia códigos de país para bandeiras emoji
      const countryFlags = {
        55: "🇧🇷", // Brasil
        351: "🇵🇹", // Portugal
        46: "🇸🇪", // Suécia
        39: "🇮🇹", // Itália
        1: "🇺🇸", // EUA/Canadá
        32: "🇧🇪", // Bélgica
        81: "🇯🇵", // Japão
        44: "🇬🇧", // Reino Unido
        61: "🇦🇺", // Austrália
        43: "🇦🇹", // Áustria
        33: "🇫🇷", // França
        49: "🇩🇪", // Alemanha
        353: "🇮🇪", // Irlanda
        41: "🇨🇭", // Suíça
        34: "🇪🇸", // Espanha
        52: "🇲🇽", // México
        31: "🇳🇱", // Holanda
        594: "🇬🇫", // Guiana Francesa
        64: "🇳🇿", // Nova Zelândia
        54: "🇦🇷", // Argentina
        244: "🇦🇴", // Angola
        376: "🇦🇩", // Andorra
        595: "🇵🇾", // Paraguai
        238: "🇨🇻", // Cabo Verde
        352: "🇱🇺", // Luxemburgo
        56: "🇨🇱", // Chile
        47: "🇳🇴", // Noruega
        502: "🇬🇹", // Guatemala
        258: "🇲🇿", // Moçambique
        971: "🇦🇪", // Emirados Árabes
        970: "🇵🇸", // Palestina
        598: "🇺🇾", // Uruguai
        591: "🇧🇴", // Bolívia
        356: "🇲🇹", // Malta
        7: "🇷🇺", // Rússia
        1849: "🇩🇴", // Rep. Dominicana
        57: "🇨🇴", // Colômbia
        234: "🇳🇬", // Nigéria
        212: "🇲🇦", // Marrocos
        45: "🇩🇰", // Dinamarca
        48: "🇵🇱", // Polônia
        974: "🇶🇦", // Catar
        1441: "🇧🇲", // Bermudas
        86: "🇨🇳", // China
        20: "🇪🇬", // Egito
        40: "🇷🇴", // Romênia
        852: "🇭🇰", // Hong Kong
        58: "🇻🇪", // Venezuela
        51: "🇵🇪", // Peru
        221: "🇸🇳", // Senegal
        82: "🇰🇷", // Coreia do Sul
        65: "🇸🇬", // Singapura
        30: "🇬🇷", // Grécia
        972: "🇮🇱", // Israel
        506: "🇨🇷", // Costa Rica
      };
      return countryFlags[code] || "🌍";
    },
    async getUser() {
      try {
        const res = await this.$userService.show(this.id);
        let data = this.$userService.prepareUser(res.data);

        // Appointments agora são carregados via lazy loading na aba
        if (data.appointments && Array.isArray(data.appointments)) {
          data.appointments = data.appointments.map((elem) =>
            this.$appointmentsService.prepareAppointment(elem)
          );
        }

        data.stripe_link = data.customer_id
          ? process.env.VUE_APP_STRIPE_BASE_URL +
            "customers/" +
            data.customer_id
          : null;

        console.log("User data:", data);
        console.log("Country code:", data.country_code);
        console.log("Phone:", data.phone);

        this.$set(this, "item", data);
        this.$set(this.form, "email", data.email);
        console.log(data.email);
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
    changeEmailClicked() {
      this.changeEmailModal.toggle();
    },
    async freeAppointment() {
      this.loadingItems = true;
      this.freeAppointmentModal.toggle();
      this.getData();
    },
    fetchPromise() {
      return this.$userService.list({
        ...this.filters,
        type: "psychologist",
      });
    },
    prepareResponse(data) {
      return data.map((elem) => {
        return this.$userService.preparePsi(elem);
      });
    },
    handleChangeEmail() {
      this.submitting = true;
      changeEmail({ id: this.item.id, email: this.form.email }, (res) => {
        console.log(res);
        this.$eventBus.$emit("showToast", {
          title: "Email alterado",
          msg: `O email foi alterado com sucesso`,
        });
        this.changeEmailModal.toggle();
        this.getUser();
        this.submitting = false;
      });
    },
    async handleFreeAppointment() {
      try {
        this.submitting = true;
        const params = {
          ...this.freeAppointmentForm,
          date: this.freeAppointmentForm.date.replace("T", " "),
        };
        const res = await this.$appointmentsService.freeAppointment(params);
        console.log(res);

        this.$eventBus.$emit("showToast", {
          title: "Sessão agendada",
          msg: `Sessão agendada com sucesso`,
        });
        this.freeAppointmentModal.toggle();
        this.$router.push({
          path: `${this.$paths.appointments.detail}/${res.data.id}`,
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.submitting = false;
      }
    },
    selectPsi(psi) {
      if (psi?.deleted_at) return;
      const psiId =
        this.freeAppointmentForm.psychologist_id == psi?.id ? null : psi?.id;
      this.$set(this.freeAppointmentForm, "psychologist_id", psiId);
    },
    changeActive() {
      changeActive(this.item, () => this.getUser());
    },
    closeReactivateModal() {
      this.showReactivateModal = false;
      this.confirmReactivate = false;
    },
    async handleReactivateAccount() {
      this.reactivating = true;
      try {
        await this.$userService.network.post("api/reactivate-user", {
          user_id: this.item.id,
        });
        this.$eventBus.$emit("showToast", {
          title: "Conta reativada",
          msg: "A conta foi reativada com sucesso",
        });
        this.closeReactivateModal();
        this.getUser();
      } catch (error) {
        this.$eventBus.$emit("showToast", {
          title: "Erro",
          msg: error.message || "Erro ao reativar conta",
        });
      } finally {
        this.reactivating = false;
      }
    },
    closeResetPasswordModal() {
      this.showResetPasswordModal = false;
      this.resetPasswordLink = null;
    },
    async handleGenerateResetLink() {
      this.generatingResetLink = true;
      try {
        const res = await this.$userService.network.post(
          `api/users/${this.item.id}/generate-password-reset-link`
        );
        this.resetPasswordLink = res.data?.data?.reset_link || res.data?.reset_link;
        this.$eventBus.$emit("showToast", {
          title: "Link gerado",
          msg: "Link de redefinição de senha gerado com sucesso",
        });
      } catch (error) {
        this.$eventBus.$emit("showToast", {
          title: "Erro",
          msg: error.message || "Erro ao gerar link",
        });
      } finally {
        this.generatingResetLink = false;
      }
    },
    copyResetLink() {
      navigator.clipboard.writeText(this.resetPasswordLink);
      this.$eventBus.$emit("showToast", {
        title: "Copiado",
        msg: "Link copiado para a área de transferência",
      });
    },
    hasPendingValueChange(recurrency) {
      if (!recurrency?.value_change_effective_at) return false;
      return this.$moment(recurrency.value_change_effective_at).isAfter(
        this.$moment()
      );
    },
    recurrencyFrequencyLabel(recurrency) {
      if (!recurrency) return "";
      if (recurrency.frequency === "weekly" && recurrency.interval === 1) return "Semanal";
      if (recurrency.frequency === "weekly" && recurrency.interval === 2) return "Quinzenal";
      if (recurrency.frequency === "monthly" && recurrency.interval === 1) return "Mensal";
      return `${recurrency.frequency} (intervalo ${recurrency.interval})`;
    },
    recurrencyDayLabel(recurrency) {
      if (!recurrency?.reference_date) return "";
      const ref = this.$moment(recurrency.reference_date);
      if (!ref.isValid()) return "";
      const minutes = ref.minute();
      const time =
        minutes === 0
          ? `${ref.hour()}h`
          : `${ref.hour()}h${String(minutes).padStart(2, "0")}`;
      if (recurrency.frequency === "weekly") {
        const weekdays = [
          "domingo",
          "segunda-feira",
          "terça-feira",
          "quarta-feira",
          "quinta-feira",
          "sexta-feira",
          "sábado",
        ];
        return `${weekdays[ref.day()]} às ${time}`;
      }
      if (recurrency.frequency === "monthly") {
        return `dia ${ref.date()} às ${time}`;
      }
      return "";
    },
    openEditRecurrencyModal(recurrency) {
      this.editRecurrencyForm.recurrency = recurrency;
      this.editRecurrencyForm.value = parseFloat(recurrency.value) || null;
      this.editRecurrencyForm.effective_date = this.$moment()
        .add(2, "days")
        .format("YYYY-MM-DD");
      this.showEditRecurrencyModal = true;
    },
    closeEditRecurrencyModal() {
      this.showEditRecurrencyModal = false;
      this.editRecurrencyForm.recurrency = null;
      this.editRecurrencyForm.value = null;
      this.editRecurrencyForm.effective_date = "";
    },
    async handleEditRecurrency() {
      if (!this.editRecurrencyForm.recurrency) return;

      const current = this.editRecurrencyForm.recurrency.value;
      const next = this.editRecurrencyForm.value;
      const date = this.$moment(
        this.editRecurrencyForm.effective_date
      ).format("DD/MM/YYYY");

      let confirmMsg = `Confirmar alteração de valor?\n\nValor atual: R$ ${current}\nNovo valor: R$ ${next}\nA partir de: ${date}`;
      if (this.editRecurrencyBigChange) {
        confirmMsg += `\n\n⚠ ATENÇÃO: variação de ${this.editRecurrencyChangePctFormatted} em relação ao valor atual.`;
      }

      const ok = confirm(confirmMsg);
      if (!ok) return;

      this.submittingEditRecurrency = true;
      try {
        await this.$appointmentsService.network.put(
          `api/appointment-recurrencies/${this.editRecurrencyForm.recurrency.id}`,
          {
            value: this.editRecurrencyForm.value,
            value_effective_from: this.editRecurrencyForm.effective_date,
          }
        );
        this.$eventBus.$emit("showToast", {
          title: "Recorrência atualizada",
          msg: `Novo valor de R$ ${this.editRecurrencyForm.value} entrará em vigor a partir de ${this.$moment(this.editRecurrencyForm.effective_date).format("DD/MM/YYYY")}.`,
        });
        this.closeEditRecurrencyModal();
        this.getData();
      } catch (error) {
        this.$eventBus.$emit("showToast", {
          title: "Erro",
          msg: error.message || "Erro ao atualizar recorrência.",
        });
      } finally {
        this.submittingEditRecurrency = false;
      }
    },
    async handleCancelRecurrency(recurrency) {
      const psiName = recurrency.psychologist?.name || "esse psi";
      const ok = confirm(
        `Tem certeza que deseja cancelar esta recorrência com ${psiName}?\n\nSomente sessões futuras que NÃO foram pagas serão canceladas.`
      );
      if (!ok) return;
      this.cancelingRecurrency = recurrency.id;
      try {
        await this.$appointmentsService.cancelRecurrency(recurrency.id);
        this.$eventBus.$emit("showToast", {
          title: "Recorrência cancelada",
          msg: "Sessões futuras que não haviam sido pagas foram canceladas.",
        });
        this.getData();
      } catch (error) {
        this.$eventBus.$emit("showToast", {
          title: "Erro",
          msg: error.message || "Erro ao cancelar recorrência.",
        });
      } finally {
        this.cancelingRecurrency = null;
      }
    },
    loadChangeLogsTab() {
      if (!this.changeLogsLoaded) {
        this.changeLogsLoaded = true;
      }
    },
    loadAppointmentsTab() {
      if (!this.appointmentsLoaded) {
        this.appointmentsLoaded = true;
        this.$nextTick(() => {
          if (this.$refs.appointmentsComponent) {
            this.$refs.appointmentsComponent.loadAppointments();
          }
        });
      }
    },
    async openUserPartnershipCodeModal() {
      this.userPartnershipCodeModal.toggle();
      this.loadingUserPartnershipCodes = true;
      this.userPartnershipCodes = [];
      this.selectedUserPartnershipCodeId = null;
      this.userPartnershipCodeError = "";

      try {
        const res = await this.$partnerService.listPartnershipCodes(
          this.item.partnership.partnership_id
        );
        this.userPartnershipCodes = res.data || [];
      } catch (e) {
        this.userPartnershipCodeError = e.message;
      } finally {
        this.loadingUserPartnershipCodes = false;
      }
    },
    selectUserPartnershipCode(codeId) {
      this.selectedUserPartnershipCodeId = codeId;
    },
    async handleUpdateUserPartnershipCode() {
      const selectedCode = this.userPartnershipCodes.find(
        (c) => c.id === this.selectedUserPartnershipCodeId
      );
      const confirmText = `Tem certeza que deseja alterar o código de parceria para "${selectedCode.code} - ${selectedCode.title}"?`;

      if (!confirm(confirmText)) return;

      this.updatingUserPartnershipCode = true;
      this.userPartnershipCodeError = "";

      try {
        await this.$partnerService.updatePartnerPatient(
          this.item.partnership.id,
          {
            partnership_code_id: this.selectedUserPartnershipCodeId,
          }
        );

        this.$eventBus.$emit("showToast", {
          title: "Código atualizado",
          msg: "Código de parceria atualizado com sucesso",
        });

        this.userPartnershipCodeModal.toggle();
        this.getUser(); // Recarrega os dados do usuário
      } catch (e) {
        this.userPartnershipCodeError = e.message;
        console.log(e);
      } finally {
        this.updatingUserPartnershipCode = false;
      }
    },
  },
  components: {
    UserDetailAppointments,
    UserDetail,
    UserChangeLogsTab,
  },
};
